import type { RotationGizmoManager } from '../rotation-gizmo-manager.class';

/**
 * Disposes all gizmo resources: removes event listeners, disposes geometries
 * and materials, and removes the gizmo group from the scene.
 */
export const disposeCfn = (self: RotationGizmoManager, _params: Record<string, never>): void => {
	const config = self.internalConfig;
	const { domElement } = config;

	// Remove event listeners
	if (self.internalHandleMouseDown) {
		domElement.removeEventListener('mousedown', self.internalHandleMouseDown);
	}
	if (self.internalHandleMouseMove) {
		domElement.removeEventListener('mousemove', self.internalHandleMouseMove);
	}
	if (self.internalHandleMouseUp) {
		window.removeEventListener('mouseup', self.internalHandleMouseUp);
	}
	if (self.internalHandleClick) {
		domElement.removeEventListener('click', self.internalHandleClick, true);
	}

	// Deactivate (removes gizmo from scene, disposes ring meshes)
	self.deactivate();

	// Clear handler references
	self.internalHandleMouseDown = null;
	self.internalHandleMouseMove = null;
	self.internalHandleMouseUp = null;
	self.internalHandleClick = null;
};
